import Card from '@material-ui/core/Card';
import deepPurple from '@material-ui/core/colors/deepPurple';
import green from '@material-ui/core/colors/green';
import orange from '@material-ui/core/colors/orange';
import yellow from '@material-ui/core/colors/yellow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import React from 'react';

const getStyle=(record)=>{
	const styleCommun={
		borderLeftWidth: 4,
		borderLeftStyle: 'solid',
	};
	const coleur= record.nature==='Encaissement reçu' ? {borderLeftColor: green[500] }:
				  record.nature==='Versement reçu' ? {borderLeftColor: yellow[500] }:
				  record.nature==='Dépense effectuée' ? {borderLeftColor: deepPurple[500] }:
				  record.nature==='Versement effectué' ? {borderLeftColor: orange[500] }:null;

	return Object.assign(styleCommun, coleur);
}

const SegmentJustif =(props)=>{
	  const { datas,cle} = props;
        if (!datas) {
            return null;
        }
	    return (
		    <Card >
		        <Table>
				<TableHead>
		                
						<TableRow >
		                    <TableCell style={{fontWeight:'bold',fontSize:14}}>
		                        Code
		                    </TableCell>
		                  	<TableCell style={{fontWeight:'bold',fontSize:14}}>
		                  		Type
		                  	</TableCell>
							  <TableCell style={{fontWeight:'bold',fontSize:14}}>
		                  		Montant
		                  	</TableCell>
		                </TableRow>
		            </TableHead>
		            <TableBody>
		               {datas.map((record,index) => (
		                    <TableRow style={ {height:42}} key={cle+index} >
								<TableCell style={getStyle(record)}><a href='http://localhost:3000/#/aerien/2249/show'>{record.code}</a></TableCell>
		                        <TableCell >{record.nature}</TableCell>
								<TableCell >{new Intl.NumberFormat().format(record.montant)}</TableCell>
		                    </TableRow>
		                ))

		            } 
		            </TableBody>
		        </Table>
		    </Card>
	    )
	
}

export default SegmentJustif;